import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDns = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "M4.95 10h10.1m-10.1 0c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C1.75 8.48 1.75 7.92 1.75 6.8v-.35c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874c.428-.218.988-.218 2.108-.218h10.1c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874c.218.428.218.988.218 2.108v.35c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C16.73 10 16.17 10 15.05 10m-10.1 0c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874c-.218.428-.218.988-.218 2.108v.35c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874c.428.218.988.218 2.108.218h10.1c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874c.218-.428.218-.988.218-2.108v-.35c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C16.73 10 16.17 10 15.05 10M4.75 6.748l2.5.001m-2.5 6.501 2.5.002"
	})]
});
const ForwardRef = forwardRef(SvgDns);
export { ForwardRef as ReactComponent };
